import TaskChangeApi from './rest/TaskChangeApi';

// todo add comment operations ???
export default new TaskChangeApi();
